/* eslint 'jsx-a11y/alt-text': 'off', eqeqeq: 'off',no-useless-escape: 'off', no-useless-concat: 'off', no-unused-vars: 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import '../../../Assets/EnsembleStyles/WorkOrders.css';
import '../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import { Col, Button, FormGroup, Label, Form, Table, Modal } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import DeleteConfirmation from '../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import UpdateWorkOrder1 from './_ModalsForms/UpdateWorkOrder';
import { GetWorkorderDetails, DeleteWorkOrder, DeleteWorkorderParts, SaveComments, UpdateComments, DeleteComments, DeleteLaborDetails, GetWorkorderTechnician, GetWorkorderTechnicianByID, GetWorkOrderBuildings, UpdateWorkOrder, DownloadAttachment, GetCustomFields } from "../../../action/workorderAction";
import { Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import AddPartsForm from "./_ModalsForms/AddPartsForm";
import AddLaborForm from "./_ModalsForms/AddLaborForm";
import { closeModalPopUp } from '../../../action/modalStateAction';
import EditIcon from '../../../Assets/images/Icons__edit.svg';
import DeleteIcon from '../../../Assets/images/Icons__trash2.svg';
// import PrintIcon from '../../../Assets/icons/icons8-print-24.png';
// import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa';
import TraneLogo from '../../../Assets/icons/Icons__trane-logo.svg';
import TraneTechLogo from '../../../Assets/icons/tt_logo_tm_color_rgb.png';
import { setAmplitudeEvent } from 'amplitude/amplitude';

let EditPartsDetails = [], EditLaborDetails = [], g_CreatedDate = new Date(), g_AssignedUserId = 0, g_DueDate = new Date(), g_Urgency = 0, WOSerialNumber = '';

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
};

class WorkOrderDetails extends Component {

    componentWillMount() {
        let WorkOrderID = this.props.WorkOrderId; 
        this.props.GetWorkorderDetails(WorkOrderID);
        this.props.GetWorkOrderBuildings();
        this.props.GetWorkorderTechnician();
        this.props.GetCustomFields();
        this.props.GetWorkorderTechnicianByID(this.props.CreatedByUserID);
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            var modalClose = nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
            if (modalClose == "close") {
                this.setState({ modal: false, labormodal: false });
            }
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            colors: [
                { backgroundColor: 'none' },
                { backgroundColor: 'white' },
                { backgroundColor: 'green' },
                { backgroundColor: 'yellow' },
                { backgroundColor: 'grey' },
                { backgroundColor: 'red' }
            ],
            ErrorMsg: "",
            modal: false,
            labormodal: false,
            isEdit: false,
            isLaborEdit: false,
            deletemodal: false,
            deleteReDirection: false,
            redirectToEdit: false,
            commentModal: 'none',
            workOrderCommentID: 0,
            onCommentChange: false,
            StatusId: this.props.StatusId,
            Status: '',
            WorkOrderId: 0,
            // sort: {
            //     column: null,
            //     direction: 'asc',
            sort: {
                column: null,
                direction:[
                  {name:'comments', direction: 'desc'},
                  {name:'createdByUserName',direction:'desc'},
                  {name:'createdOn',direction:'desc',onclick:true},
                  {name:'partName',direction:'desc'},
                  {name:'partNumber',direction:'desc'},
                  {name:'quantity',direction:'desc'},
                  {name:'userName',direction:'desc'},
                  {name:'dateOfService',direction:'desc'},
                  {name:'regularHour',direction:'desc'},
                  {name:'timeDuration',direction:'desc'},
                ],
            },
            isCommentEmpty: false
        };

        this.Delete = this.Delete.bind(this);
        this.OpenDeletePopup = this.OpenDeletePopup.bind(this);
        this.toggle = this.toggle.bind(this);
        this.Edittoggle = this.Edittoggle.bind(this);
        this.DeleteParts = this.DeleteParts.bind(this);
        this.switchEditView = this.switchEditView.bind(this);
        this.Labortoggle = this.Labortoggle.bind(this);
        this.DeleteLabor = this.DeleteLabor.bind(this);
        this.OnStatusChange = this.OnStatusChange.bind(this);
        this.OnStatusSort = this.OnStatusSort.bind(this);
        this.AttachmentDownload = this.AttachmentDownload.bind(this);
        this.OpenPrintPreview = this.OpenPrintPreview.bind(this);
    }

    OnStatusChange() {
        let WorkOrderID = this.props.WorkOrderId;
        var selectedOption = this.refs.status_in_Select_input.options.selectedIndex;
        var lStatusId = this.refs.status_in_Select_input.options[selectedOption].id;

        this.setState({
            StatusId: lStatusId,
            Status: this.refs.status_in_Select_input.options[selectedOption].value,
        });

        if (lStatusId > 0) {
            let lineitem = {
                "WorkOrderID": WorkOrderID,
                "Status": lStatusId,
                "AssignedUserID": g_AssignedUserId,
                "DueDate": g_DueDate,
                "Urgency": g_Urgency,
                "CreatedByDate": g_CreatedDate
            }
            this.props.UpdateWorkOrder(lineitem, WorkOrderID);
        }
    }

    OnStatusSort(values) {
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }

    onCommentSort = (column) => (e) => {
        var copydata = this.state.sort.direction.slice();
        var selected = copydata.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getDetails.WorkOrderDetails.workOrderComment;
        var notequals = 0;
        if (data_from_state !== null) {
            const sortedData = this.props.getDetails.WorkOrderDetails.workOrderComment.sort((a, b) => {
                let nameA, nameB;
                if (column === "createdByUserName" || column === "comments") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                }
                else {
                    nameA = new Date(a[column]);
                    nameB = new Date(b[column]);
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            this.props.getDetails.WorkOrderDetails.workOrderComment = sortedData;
            if(selected[0].name == "comments"){
                copydata[0].direction = direction; 
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "comments") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});                 
            }
            if(selected[0].name == "createdByUserName"){
                copydata[1].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "createdByUserName") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array}); 
                
            }
            if(selected[0].name == "createdOn"){
                copydata[2].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});                
            }
            this.setState({
                sort: {
                    column,
                    direction:copydata,
                },
                onCommentChange:true,
            });
        }
        return 0;
    }

    onPartsSort = (column) => (e) => {
        var copydata = this.state.sort.direction.slice();
        var selected = copydata.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getDetails.WorkOrderDetails.workOrderPart;
        var notequals = 0;
        if (data_from_state !== null) {
            const sortedData = this.props.getDetails.WorkOrderDetails.workOrderPart.sort((a, b) => {
                let nameA, nameB;
                if (column === "partName" || column === "partNumber") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                }
                else {
                    nameA = a[column];
                    nameB = b[column];
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            this.props.getDetails.WorkOrderDetails.workOrderPart = sortedData;
            if(selected[0].name == "partName"){
                copydata[3].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "partName" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            if(selected[0].name == "partNumber"){
                copydata[4].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "partNumber" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            if(selected[0].name == "quantity"){
                copydata[5].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "quantity" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            this.setState({
                sort: {
                    column,
                    direction:copydata,
                },
            });
        }
        return 0;
    };

    onLaborSort = (column) => (e) => {
        var copydata = this.state.sort.direction.slice();
        var selected = copydata.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getDetails.WorkOrderDetails.workOrderLabor;
        var notequals = 0;
        if (data_from_state !== null) {
            const sortedData = this.props.getDetails.WorkOrderDetails.workOrderLabor.sort((a, b) => {
                let nameA, nameB;
                if (column === "userName") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                }
                else {
                    if (column === "regularHour" || column === "timeDuration") {
                        nameA = a[column];
                        nameB = b[column];
                    }
                    else {
                        nameA = new Date(a[column]);
                        nameB = new Date(b[column]);
                    }
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            this.props.getDetails.WorkOrderDetails.workOrderLabor = sortedData;
            if(selected[0].name == "userName"){
                copydata[6].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "userName" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            if(selected[0].name == "dateOfService"){
                copydata[7].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "dateOfService" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            if(selected[0].name == "regularHour"){
                copydata[8].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "regularHour" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            if(selected[0].name == "timeDuration"){
                copydata[9].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "timeDuration" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            this.setState({
                sort: {
                    column,
                    direction:copydata,
                },
            });
        }
        return 0;
    }

    // setArrow = (column) => {
    //     let className = 'workorder-sort-direction';
    //     if (this.state.sort.column === column) {
    //         className += this.state.sort.direction === 'asc' ? ' asc' : ' desc';
    //     }
    //     return className;
    // };

    toggleWoList() {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;

        if(IsEquipment)
        {
            this.props.UpdateRedirection();
            this.props.ShowCreateButton();
        }

        this.setState({ deleteReDirection: true });
    }
    toggleComments() {
        this.refs.WorkOrder_Comments.value = "";
        this.refs.ref_Comment_Notify.checked = false;
        this.setState({ workOrderCommentID: 0, isCommentEmpty:false });
        if (this.state.commentModal === 'none')
            this.setState({ commentModal: 'block' });
        else
            this.setState({ commentModal: 'none' });
    }

    SaveComments() {
        var lComment = this.refs.WorkOrder_Comments.value;
        let isValid = (lComment !== "") ? true : false;
        this.setState({onCommentChange:false, isCommentEmpty:false});
        if(isValid){
            var data = {
                Comments: lComment,
                CreatedByUserID: 1,
                WorkOrderID: this.props.getDetails.WorkOrderDetails.workOrderID,
                commentId: this.state.workOrderCommentID,
                IsNotifyCreator: this.refs.ref_Comment_Notify.checked
            }
            if (this.state.workOrderCommentID !== 0){
                this.props.SaveComments(data);
            }
            else{
                if(this.refs.ref_Comment_Notify.checked){
                    let wo_Created_In = (this.props.getDetails.WorkOrderDetails.workOrderForm !== null && this.props.getDetails.WorkOrderDetails.workOrderForm.isCustomerForm ) ? "Service Request UI" : "Ensemble or Facility Request UI";
                    setAmplitudeEvent("Sent Comment Email Notification ",{"WO Created In": wo_Created_In});
                }
                this.props.UpdateComments(data);
            }
            this.toggleComments();
            this.refs.ref_Comment_Notify.checked = false;
        }
        else{
            this.setState({isCommentEmpty: true})
        }
    }

    EditComments(ID, lComments) {
        if (this.state.commentModal === 'none')
            this.setState({ commentModal: 'block' });
        this.setState({ workOrderCommentID: ID });
        this.refs.WorkOrder_Comments.value = lComments;
    }

    DeleteComments(ID) {
        var data = {
            WorkOrderID: this.props.getDetails.WorkOrderDetails.workOrderID,
            commentId: ID
        }
        this.props.DeleteComments(data);
    }

    Delete(someArg) {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        if (someArg == "yes") {
            let lData = [];
            lData.push(this.props.getDetails.WorkOrderDetails.workOrderID);
            if(IsEquipment){
                this.props.DeleteWorkOrder(lData, this.props.getDetails.WorkOrderDetails.workOrderDetail.equipmentID);
                this.props.UpdateRedirection();
                this.props.ShowCreateButton();
            }else{
                this.props.DeleteWorkOrder(lData, 0);
            }
            
            this.setState({ deleteReDirection: true });
        }
        else {
            this.Deletetoggle();
        }
    }

    OpenDeletePopup() {
        this.Deletetoggle();
    }

    switchEditView() {
        this.setState({
            redirectToEdit: !this.state.redirectToEdit
        });
    }

    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }
    toggle() {
        EditPartsDetails = [];
        this.props.closeModalPopUp("open");
        this.setState({
            modal: true,
            isEdit: false
        });
    }

    Edittoggle(Name, number, quantity, PartId) {
        EditPartsDetails = [];
        this.props.closeModalPopUp("open");
        EditPartsDetails.push({ partName: Name, partNumber: number, quantity: quantity, partId: PartId });
        this.setState({
            modal: true,
            isEdit: true
        })
    }


    DeleteParts(element) {
        this.props.DeleteWorkorderParts(element);
    }

    Labortoggle() {
        this.props.closeModalPopUp("open");
        this.setState({
            labormodal: true,
            isLaborEdit: false
        });
    }

    EditLabor(data) {
        EditLaborDetails = [];
        this.props.closeModalPopUp("open");
        EditLaborDetails.push({ workOrderLaborID: data.laborId, userName: data.userName, dateOfService: data.dateOfService, regularHour: data.regularHour, timeDuration: data.timeDuration });
        this.setState({
            labormodal: true,
            isLaborEdit: true
        })
    }

    DeleteLabor(element) {
        this.props.DeleteLaborDetails(element);
    }

    AttachmentDownload(fileName){
        this.props.DownloadAttachment(fileName);
    }

    OpenPrintPreview(){
        var imgURL = document.getElementById('test_trane_logo').src;
        document.getElementById('PrintWOSummary').setAttribute('style','display:block');
        var CurrentDateTime = new Date(); 
        var CurrentTime = CurrentDateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        var CurrentDate = (CurrentDateTime.getMonth()+1) + '/' + CurrentDateTime.getDate() + '/' + CurrentDateTime.getFullYear() + ', ' + CurrentTime;
        var printContent = document.getElementById('divPrintWindow').outerHTML;
        var PrintSummaryContent = document.getElementById('PrintWOSummary').outerHTML;
        var WindowHeight = ((window.screen.height)-200) + 'px';
        var WindowWidth = ((window.screen.width)-10) + 'px';
        var printWindow = window.open('', 'printwindow', 'height='+WindowHeight+', width='+WindowWidth+', resizable=1, toolbar=no, menubar=no, scrollbars=yes, location=no, directories=no, status=no');
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;" ><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');

        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div style='display:block !important;' class=\'row row_padding\'><div class='\col-md-12\'>");
        writeMe += ("<br/><label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float:left;margin-left:16px;'>Work Order Management</label><label class=\'workOrderlabel'\ style='float:right;margin-right:16px;'>"+CurrentDate+"</label><br/>");
        writeMe += ("<div style='margin:16px'><nav style='position: relative;display: -webkit-flex;display: flex;-webkit-flex-wrap: wrap;flex-wrap: wrap;-webkit-align-items: center;align-items: center;-webkit-justify-content: space-between;justify-content: space-between;padding: .5rem 1rem;background: transparent linear-gradient(270deg, #104095 0%, #2070CF 100%) 0% 0% no-repeat padding-box !important; min-height: 54px;-webkit-flex-flow: row nowrap;flex-flow: row nowrap;-webkit-justify-content: flex-start;justify-content: flex-start;'><a><img id='Trane_Logo' src="+imgURL+"></a></nav></nav></div>");
        writeMe += ("<label style='height: 15px;text-align: left;letter-spacing: 0px;color: #4A4A4A;opacity: 1;font-weight: bold;font-family: lato;font-size: 15px;padding-left: 15px;'>"+WOSerialNumber+"</label><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/>");
        writeMe += ("<div id='divWODetailsPrintPreview'>" + printContent + PrintSummaryContent + "</div>");
        writeMe += ("<br/><br/><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/>");
        writeMe += ("<label class=\'print_footer'\ style='padding-left: 16px; padding-bottom: 3px;'>Tracer Ensemble<br/>2020 Trane Technologies | Privacy Policy | Terms of Use<br/>Page 1 of 1</label>");
        writeMe += ("<div style='float:right'><img id='TraneTech_Logo' style='height: 30px;width: 142px;padding-right: 11px;' src="+TraneTechLogo+" \></div><br/>");
        writeMe += ("<div style='borderTop:1px solid #FFFFFF; padding-bottom: 50px;'/><div style='margin-top:10px; margin-bottom:25px; margin-right:5px'><div style='float:right;'>");
        writeMe += ('<button type=\'button\' class=\'wo_cancel_btn hide_in_print\' style=\'color: #1756B2;border:0px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;width: 80px;height: 30px;float: right; margin-left: 6px; margin-top:3px; margin-right:10px; width:106px\' id=\'btnPrint\' onclick=\'javascript:window.close();\' >' + 'Close Window' + '</button>');
        writeMe += ('<button type=\'button\' class=\'wo_save_btn hide_in_print\' style=\'border:0px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;float: right; margin-left: 6px; margin-top:3px\' id=\'btnPrint\' onclick=\'javascript:window.print();\' >' + 'Print' + '</button>');
        writeMe += ("</div></div><br/>");
        writeMe += ('</body></html>');    
        printWindow.document.write(writeMe);
        printWindow.document.close();    
        printWindow.focus();
        document.getElementById('PrintWOSummary').setAttribute('style','display:none');
    }

    FormEmptyCustomFields(){
        const l_rows = [];
        if(this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length){
            var lCustomFields = this.props.getCustomFields.filter(el => el.display === true);
            if(lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length){
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lstCustomFields = l_CustomFields.map((item) => {
                    return <Col sm={{ size: 2 }}>
                        <Label className='workorderheaderlbl'>{item.fieldLabel}</Label><br />
                        <Label className="workorderlbl">---</Label>
                    </Col>
                });
                
                // Push a new row for every set of three fields
                for (let row = 0; row < Math.ceil(l_CustomFields.length / 3); row++) {
                    l_rows.push(<div className="row form-group">
                        {l_lstCustomFields.slice((row * 3), ((row + 1) * 3))}
                    </div>);
                };
            }
        }
        return l_rows;
    }

    FormCustomFields(WoCustomFields){
        const l_rows = [];
        if(this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length){
            var lCustomFields = this.props.getCustomFields.filter(el => el.display === true);
            if(lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length){
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lstCustomFields = l_CustomFields.map((item) => {
                    var SelectedValues = WoCustomFields.filter(el => el.customFieldID === item.fieldId);
                    var l_Value = "";
                    if(SelectedValues[0] !== undefined && SelectedValues[0] !== null){
                        if(item.fieldType === 0) 
                        l_Value = SelectedValues[0].customFieldTextValue;
                        else
                        {
                            if (item.value !== undefined && item.value !== null && item.value.length > 0) {
                                var l_Values = item.value.filter(ele => ele.key === SelectedValues[0].customFieldValueID);
                                l_Value = (l_Values[0] !== undefined && l_Values[0] !== null) ? l_Values[0].value : "";
                            }
                        }
                    }
                    return <Col sm={{ size: 2 }}>
                        <Label className='workorderheaderlbl'>{item.fieldLabel}</Label><br />
                        <Label className="workorderlbl">{l_Value !== "" ? l_Value : "---"}</Label>
                    </Col>
                });
                
                // Push a new row for every set of three fields
                for (let row = 0; row < Math.ceil(l_CustomFields.length / 3); row++) {
                    l_rows.push(<div className="row form-group">
                        {l_lstCustomFields.slice((row * 3), ((row + 1) * 3))}
                    </div>);
                };
            }
        }
        return l_rows;
    }

    OnSort(values) {
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }

    render(getLabels, getDetails, getWorkorderPreferences,UserCanEdit) {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        let label = this.props.getLabels;
        let Parts, Data = null, Labors;
        let WODetails = this.props.getDetails.WorkOrderDetails;
        let preferredfields = this.props.getWorkorderPreferences;

        let lUserCanEdit;
        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit === 3 ? true : false;
        let HasMailSetting = this.props.getMailSetting;
        let HasEmailAddress = false;

        var tenant = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Tenant" && x.display === true) : "";
        var building = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Building" && x.display === true) : "";
        var floor = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Floor" && x.display === true) : "";
        var space = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Space" && x.display === true) : "";
        var problem = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Problem" && x.display === true) : "";
        var description = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Description" && x.display === true) : "";
        var urgency = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Urgency" && x.display === true) : "";
        var equipment = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Equipment" && x.display === true) : "";
        var status = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
        var assignedto = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : "";
        var createdby = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Created" && x.display === true) : "";
        var notifyOthers = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Notify Others" && x.display === true) : "";
        var dueDate = preferredfields !== undefined ? preferredfields.filter(x => x.field === "DueDate" && x.display === true) : "";

        //eslint-disable-next-line
        let WOStatus, WOAssignedTo,IsClosedStatus = 'block', WOScheduledDate, WOClosedDate, WOUrgency, WOTenant, WOBuilding, WOFloor, WOSpace, WOProblem, WOEquipment, WOEquipmentID, WODescription, IsPastDue = false, WOAttachements, WOComments, WORequestedBy, WOEmail, WONotifyOthers;
        if (this.state.deleteReDirection && !IsEquipment) {
            return <Redirect to={"/ManageWorkOrder"} />
        }else if(this.state.deleteReDirection && IsEquipment){
            return <Redirect to ={"/EquipmentWrapper"}/>
        }


        let PrintWOAttachements,PrintParts,PrintLabor,PrintWOComments, WOCustomFields = [], IsWOForm;
        if (WODetails !== undefined && WODetails !== null && WODetails.workOrderDetail !== undefined) {
            g_CreatedDate = WODetails.createdByDate;
            g_AssignedUserId = WODetails.assignedUserID;
            g_DueDate = WODetails.dueDate;
            g_Urgency = WODetails.urgency;
            WOSerialNumber = WODetails.serialNumber;
            WOEmail = WODetails.isMailRequired;
            IsWOForm = (WODetails.workOrderForm !== undefined && WODetails.workOrderForm !== null) ? WODetails.workOrderForm.isCustomerForm : false;
            
            IsClosedStatus = WODetails.status === 6 ? 'none' : 'block';

            if (status.length > 0 && status[0].value.length > 0) {
                if(status[0].value.filter(el => el.key == WODetails.status)[0] != undefined)
                {
                    var SelectedStatus = status[0].value.filter(el => el.key == WODetails.status);
                    WOStatus = SelectedStatus[0].value;
                }
            }
            //WOStatus = label['WorkOrders.Status.' + WODetails.status + '.Text'];
            var TechnicianName = '';
            if (this.props.getTechnicianList != undefined && this.props.getTechnicianList.length) {
                if(this.props.getTechnicianList.filter(el => el.technicianID == WODetails.assignedUserID)[0] != undefined)
                {
                   var TechName = this.props.getTechnicianList.filter(el => el.technicianID == WODetails.assignedUserID);
                   TechnicianName = (TechName[0] !== undefined && TechName[0] !== null) ? TechName[0].name : '';
                }
            }
            var NotifyOtherslst = <Label className="workorderlbl">---</Label>;
            if(WODetails.notifyUserIDs.length && WODetails.notifyUserIDs !== undefined && WODetails.notifyUserIDs !== null){
                NotifyOtherslst = WODetails.notifyUserIDs.map(e => {
                    var technicianName = this.props.getTechnicianList.filter(el => el.technicianID == e)[0].name
                    return (
                        <>
                       <Label className="workorderlbl">{technicianName}</Label><br/>
                        </>
                    )
                })
            }
            if(IsWOForm){
                HasEmailAddress = true;
            }else{
                if(this.props.getTechnicianDetails !== undefined && this.props.getTechnicianDetails[0] !== undefined){
                    HasEmailAddress = (this.props.getTechnicianDetails[0].emailAddress !== "" && this.props.getTechnicianDetails[0].emailAddress !== null) ? true : false;
                }
            }
            WOAssignedTo = (TechnicianName != "" ? TechnicianName : "---");
            WONotifyOthers = NotifyOtherslst;
            WOScheduledDate = WODetails.dueDate === '1753-01-01T00:00:00' ? '---' : new Date(WODetails.dueDate).toDateString();
            WOClosedDate = WODetails.closedDate === '1753-01-01T00:00:00' ? '---' : new Date(WODetails.closedDate).toDateString();
            WOUrgency = (WODetails.urgency > 0) ? (urgency.length > 0) ? urgency[0].value.filter(x => x.key == WODetails.urgency)[0].value : "Low" : "---";
            WOTenant = WODetails.workOrderDetail.tenantName !== "" ? WODetails.workOrderDetail.tenantName : '---';
            var l_SiteId = WODetails.workOrderDetail.siteID;
            var l_FloorId = WODetails.workOrderDetail.floorID;
            var l_SpaceId = WODetails.workOrderDetail.spaceID;

            var l_Buildings = l_SiteId > 0 ? (this.props.getWorkOrderBuildings.filter(el => el.id == l_SiteId)[0] ? this.props.getWorkOrderBuildings.filter(el => el.id == l_SiteId)[0] : null) : null;
            var l_Floors = l_Buildings != null && l_FloorId > 0 && l_Buildings.floors.filter(e => e.id == l_FloorId)[0] != undefined ? l_Buildings.floors.filter(e => e.id == l_FloorId)[0] : null;
            var l_Rooms = l_FloorId > 0 ? l_Floors.spaces : (l_SiteId > 0 && l_Buildings != null) ? l_Buildings.spaces : null
            
            WOBuilding = (l_SiteId > 0 && l_Buildings != undefined) ? l_Buildings.name : '---';
            WOFloor = (l_Buildings != undefined && l_Buildings != null && l_FloorId > 0 && l_Buildings.floors.filter(e => e.id == l_FloorId)[0] != undefined) ? l_Buildings.floors.filter(e => e.id == l_FloorId)[0].name : '---';
            WOSpace = (l_Rooms != undefined && l_Rooms != null && l_SpaceId > 0) ? l_Rooms.filter(el => el.id == l_SpaceId)[0] !== undefined ? l_Rooms.filter(el => el.id == l_SpaceId)[0].name : '---' : '---';
            WOProblem = (WODetails.workOrderDetail.problemID > 0) ? (problem.length > 0) ? problem[0].value.filter(x => x.key == WODetails.workOrderDetail.problemID)[0].value : "Light not working" : "---";
            WOEquipment = (WODetails.workOrderDetail.equipmentName !== "" ? WODetails.workOrderDetail.equipmentName : "---");
            WOEquipmentID = WODetails.workOrderDetail.equipmentID;
            WODescription = WODetails.description;
            WORequestedBy = (IsWOForm ? WODetails.workOrderForm.emailAddress : WODetails.createdByUserName) + ' | ' + new Date(WODetails.createdByDate).toDateString();

            //To handle the virtual building delete from WO Building tab/from Ensemble
            if(l_Buildings != undefined && l_Buildings != null && WOEquipment !== "---"){
                if(l_Buildings.isDeleted || (l_Buildings.siteId === 0 && !WODetails.workOrderDetail.isNonDiscoveredEquipment)){
                    WOEquipment = "---";
                    WOEquipmentID = 0;
                }
            }

            if (WOScheduledDate !== '---') {
                // var l_date = new Date();
                // var SheduleDate = new Date(WODetails.dueDate).setHours(0, 0, 0, 0);
                // l_date.setHours(0, 0, 0, 0); //discard the time

                // if (Number(SheduleDate) < Number(l_date)) {
                //     IsPastDue = true;
                // }
                IsPastDue = WODetails.status === 6 ? false : WODetails.isDueDatePassed;
            }

            if (WODetails.workOrderAttachment !== [] && WODetails.workOrderAttachment.length) {
                var lAttachements = WODetails.workOrderAttachment;
                WOAttachements = lAttachements.map(el => (
                    <tr>
                        <td className="link_cursorUnderline" onClick={() => {this.AttachmentDownload(el.fileName)}}>{el.attachmentName}</td>
                    </tr>
                ));
                PrintWOAttachements = lAttachements.map(el => (
                    <tr>
                        <td>{el.attachmentName}</td>
                    </tr>
                ));
            }
            else{
                WOAttachements = <tr><td className="workorderlbl-noentry">{"No attachments"}</td></tr> 
                PrintWOAttachements = <tr><td className="workorderlbl-noentry">{"No attachments"}</td></tr> 
            }

            if (WODetails.workOrderComment !== undefined && WODetails.workOrderComment !== [] && WODetails.workOrderComment.length) {
                let comment = WODetails.workOrderComment;
                if(!this.state.onCommentChange){
                    let comments = comment.sort((a,b)=>{
                        let nameA = a.createdOn;
                        let nameB = b.createdOn;
                        if(nameA < nameB)
                            return(-1);
                        else
                            return(1);
                    });
                    comment = comments.reverse();
                 }
                WOComments = comment.map(el => (
                    <tr key={el.commentId}>
                        <td>{el.comments}</td>
                        <td>{el.createdByUserName !== "" ? el.createdByUserName : ''}</td>
                        <td>{new Date(el.createdOn).toDateString()}</td>
                        <td width="11%">
                            <img src={EditIcon} style={{width:'18px'}} onClick={() => { this.EditComments(el.commentId, el.comments) }} />
                            <img src={DeleteIcon}  style={{width:'18px', marginLeft:'3px', valign:'bottom' }}  className="link_cursor" onClick={() => { this.DeleteComments(el.commentId) }} />
                        </td>
                    </tr>
                ));
                PrintWOComments = comment.map(el => (
                    <tr key={el.commentId}>
                        <td>{el.comments}</td>
                        <td>{el.createdByUserName !== "" ? el.createdByUserName : ''}</td>
                        <td>{new Date(el.createdOn).toDateString()}</td>
                    </tr>
                ));
            } else {
                WOComments = <tr><td className="workorderlbl-noentry" colSpan="4">No Entry</td></tr>;
                PrintWOComments = <tr><td className="workorderlbl-noentry" colSpan="4">No Entry</td></tr>;
            }

            if (WODetails.workOrderPart !== undefined && WODetails.workOrderPart.length) {
                Data = WODetails.workOrderPart;
                Parts = Data.map(el => (
                    <tr key={el.workOrderPartID}>
                        <td width="30%">{el.partName}</td>
                        <td width="30%">{el.partNumber === "" ? '' : el.partNumber}</td>
                        <td width="24%">{el.quantity === 0 ? '' : el.quantity}</td>
                        <td width="11%">
                            <img src={EditIcon} style={{width:'18px'}} onClick={() => { this.Edittoggle(el.partName, el.partNumber, el.quantity, el.partId) }} />
                            <img src={DeleteIcon}  style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteParts(el) }} />
                        </td>
                    </tr>
                ));
                PrintParts = Data.map(el => (
                    <tr>
                        <td width="30%">{el.partName}</td>
                        <td width="30%">{el.partNumber === "" ? '' : el.partNumber}</td>
                        <td width="24%">{el.quantity === 0 ? '' : el.quantity}</td>
                    </tr>
                ));
            } else {
                Parts = <tr><td className="workorderlbl-noentry" colSpan="4">No Entry</td></tr>;
                PrintParts = <tr><td className="workorderlbl-noentry" colSpan="3">No Entry</td></tr>;
            }

            if (WODetails.workOrderLabor !== undefined && WODetails.workOrderLabor.length) {
                Labors = WODetails.workOrderLabor.map(el => (
                    <tr key={el.workOrderLaborID}>
                        <td width="25%">{el.userName}</td>
                        <td width="25%">{el.dateOfService === "1753-01-01T00:00:00" ? '' : new Date(el.dateOfService).toDateString()}</td>
                        <td width="20%">{el.regularHour === 0 ? '' : el.regularHour}</td>
                        <td width="19%">{el.timeDuration === 0 ? '' : el.timeDuration}</td>
                        <td width="11%">
                            <img src={EditIcon} style={{width:'18px'}} onClick={() => { this.EditLabor(el) }} />
                            <img src={DeleteIcon}  style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteLabor(el) }} />
                        </td>
                    </tr>
                ))
                PrintLabor = WODetails.workOrderLabor.map(el => (
                    <tr>
                        <td width="25%">{el.userName}</td>
                        <td width="25%">{el.dateOfService === "1753-01-01T00:00:00" ? '' : new Date(el.dateOfService).toDateString()}</td>
                        <td width="20%">{el.regularHour === 0 ? '' : el.regularHour}</td>
                        <td width="19%">{el.timeDuration === 0 ? '' : el.timeDuration}</td>
                    </tr>
                ))
            } else {
                Labors = <tr><td className="workorderlbl-noentry" colSpan="5">No Entry</td></tr>
                PrintLabor = <tr><td className="workorderlbl-noentry" colSpan="5">No Entry</td></tr>
            }

            if (WODetails.workOrderCustomFields !== undefined && WODetails.workOrderCustomFields !== null && WODetails.workOrderCustomFields.length) {
                WOCustomFields = this.FormCustomFields(WODetails.workOrderCustomFields);
            }else{
                WOCustomFields = this.FormEmptyCustomFields();
            }
        }

        let PrintWOSummary = <div>
            <FormGroup row>
                {
                    <Col sm={{ size: 8 }}>
                        <Label className="workorderlbl" style={{ 'margin-bottom': '10px' }}>Attached Documents or Photos</Label><br />
                        <Table responsive className="attachmentTable" style={{ width: "90%", border: "none" }}>
                            <tbody>
                                <tr><th>FILE NAME</th></tr>
                                {PrintWOAttachements}
                            </tbody>
                        </Table>
                    </Col>
                }
            </FormGroup>
            <hr style={{ 'margin-bottom': '0px', 'background-color': 'black' }} />
            <FormGroup row>
                <Col sm={{ size: 12 }}>
                    <Label style={{ "padding-top": "24px" }} className='workorderlbl'>{label['WorkOrderDetails.WorkSummary.Text'] !== undefined ? label['WorkOrderDetails.WorkSummary.Text'] : "WORK SUMMARY"}</Label>
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-bottom": "0px", "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrders.ViewDetails.Parts.Text'] !== undefined ? label['WorkOrders.ViewDetails.Parts.Text'] : "Parts"}</Label> &ensp;
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <div className="table_container" style={{ "margin-left": "16px" }}>
                        <Table striped responsive className="Custom_table" style={{ 'table-layout': 'fixed' }}>
                            <tbody className="cell_container">
                                <tr>
                                    <th width="20%">{label['WorkOrders.PartsName.Text'] !== undefined ? label['WorkOrders.PartsName.Text'] : "NAME"}</th>
                                    <th width="40%">{label['WorkOrders.PartNumber.Text'] !== undefined ? label['WorkOrders.PartNumber.Text'] : "PART #"}</th>
                                    <th width="20%">{label['WorkOrders.PartQuantity.Text'] !== undefined ? label['WorkOrders.PartQuantity.Text'] : "QUANTITY"}</th>
                                </tr>
                                {PrintParts}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-bottom": "0px", "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Labor.text'] !== undefined ? label['WorkOrderDetails.Labor.text'] : "Labor"}</Label> &ensp;
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <div className="table_container" style={{ "margin-left": "16px" }}>
                        <Table striped responsive className="Custom_table" style={{ 'table-layout': 'fixed' }}>
                            <tbody className="cell_container">
                                <tr>
                                    <th width="20%">{label['WorkOrders.LaborName.Text'] !== undefined ? label['WorkOrders.LaborName.Text'] : "NAME"}
                                    </th>
                                    <th width="20%">{label['WorkOrders.LaborDateofService.Text'] !== undefined ? label['WorkOrders.LaborDateofService.Text'] : "DATE OF SERVICE"}
                                    </th>
                                    <th width="20%">{label['WorkOrders.LaborRegularHours.Text'] !== undefined ? label['WorkOrders.LaborRegularHours.Text'] : "REGULAR HOURS"}
                                    </th>
                                    <th width="20%">{label['WorkOrders.LaborOvertime.Text'] !== undefined ? label['WorkOrders.LaborOvertime.Text'] : "OVERTIME"}
                                    </th>
                                </tr>
                                {PrintLabor}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-bottom": "0px", "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Comments.Text'] !== undefined ? label['WorkOrderDetails.Comments.Text'] : "Comments"}</Label> &ensp;
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <div className="table_container" style={{ "margin-left": "16px" }}>
                        <Table striped responsive className="Custom_table fixed_layout">
                            <tbody className="cell_container">
                                <tr>
                                    <th width="40%" onClick={this.onCommentSort('comments')}>{label['WorkOrders.Comments.Text'] !== undefined ? label['WorkOrders.Comments.Text'] : "COMMENTS"}
                                    </th>
                                    <th width="20%" onClick={this.onCommentSort('createdByUserName')}>{label['WorkOrders.CreatedBy.Text'] !== undefined ? label['WorkOrders.CreatedBy.Text'] : "CREATED BY"}
                                    </th>
                                    <th width="20%" onClick={this.onCommentSort('createdOn')}>{label['WorkOrders.CreatedDate.Text'] !== undefined ? label['WorkOrders.CreatedDate.Text'] : "CREATED DATE"}
                                    </th>
                                </tr>
                                {PrintWOComments}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </FormGroup>
        </div>

        return (
            <div>
                {
                    this.state.redirectToEdit ? <UpdateWorkOrder1 TaskId={this.props.getDetails.WorkOrderDetails.workOrderID} Equipment={WOEquipment} ForEquipment={this.props.ForEquipment} EquipmentID={WOEquipmentID} Premise={this.props.Premise} ShowCreateButton={this.props.ShowCreateButton} UpdateRedirection={this.props.UpdateRedirection} /> :
                        <div className= {this.props.Premise ? "main_container" : "cloud_main_container"}>
                            <Form>
                                <FormGroup row style={{"margin-bottom":"1px"}}>
                                    <Col sm={{ size: 4 }}>
                                        <Label style={{fontFamily:'Lato',fontSize:'14px',color:'black'}} className = "link_cursorUnderlineBlack" onClick={() => { this.toggleWoList() }}>{"Work Order  "}</Label>
                                        <Label style={{fontFamily:'Lato',fontSize:'14px',color:'black'}}>{" > "}{WOSerialNumber}</Label>
                                    </Col>
                                    <Col sm={{ size: 8 }}>
                                        { lUserCanEdit ? <img src={DeleteIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', valign: 'bottom', 'margin-top': '1px',width:'15px',height:'14px'}} onClick={this.OpenDeletePopup} /> : "" }
                                        <FaPrint className="icons-Menu-print" style={{"margin-right":"5px",'display':this.props.ForEquipment ?'none':'block'}} onClick={this.OpenPrintPreview} />
                                        <img src={EditIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', 'margin-top': '1px',width:'15px',height:'14px',"display": IsClosedStatus }} onClick={this.switchEditView} />
                                    </Col>
                                </FormGroup>
                                <FormGroup row style={{"margin-bottom":"1px"}}>
                                   <Col sm={{ size: 2 }}>
                                        <Label style={{fontFamily:'Lato',fontSize:'15px',color:'black'}}>{WOSerialNumber}</Label>
                                    </Col>
                                </FormGroup>
                                <div id="divPrintWindow">
                                <FormGroup row>
                                    {
                                        (status.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{status[0].fieldLabel}</Label><br/>
                                                <Label className="workorderlbl">{WOStatus}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (assignedto.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{assignedto[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOAssignedTo}</Label><br />                                                
                                            </Col> : ""
                                    }
                                    {
                                        (notifyOthers.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{notifyOthers[0].fieldLabel}</Label><br />
                                                {WONotifyOthers}                                                           
                                            </Col> : ""
                                    }
                                    {
                                        (createdby.length > 0) ?
                                            <Col sm={{ size: 3 }}>
                                                <Label className='workorderheaderlbl'>{createdby[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WORequestedBy}</Label>
                                            </Col> : ""
                                    }
                                </FormGroup>
                                <FormGroup row>
                                    {
                                        (urgency.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{urgency[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOUrgency}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (dueDate.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{label['WorkOrderDetails.SheduledDate.Text'] !== undefined ? label['WorkOrderDetails.SheduledDate.Text'] : "Scheduled Date"}</Label><br />
                                                {
                                                    IsPastDue ?
                                                        <div><Label className="workorderlbl" style={{'margin-bottom':'1px'}}>{WOScheduledDate}</Label><Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} /><Label style={{ 'color': 'red' }} >Past Due</Label></div>
                                                        : <Label className="workorderlbl">{WOScheduledDate}</Label>
                                                }
                                            </Col> : ""
                                    }
                                </FormGroup>
                                
                                <FormGroup row>
                                {
                                        (WODetails !== undefined && WODetails.status === 6) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{label['WorkOrderDetails.ClosedDate.Text'] !== undefined ? label['WorkOrderDetails.ClosedDate.Text'] : "Closed Date"}</Label><br />
                                                <Label className="workorderlbl">{WOClosedDate}</Label>
                                            </Col> : ""
                                }
                                </FormGroup>

                                <hr style={{backgroundColor:'#666666',height:'1px',border:'none'}}/>
                                <FormGroup row>
                                    <Col sm={{ size: 2 }}>
                                        <Label className='workordersubheaderlbl printview'>{label['WorkOrderDetails.Details.Text'] !== undefined ? label['WorkOrderDetails.Details.Text'] : "DETAILS"}</Label>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    {
                                        (building.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{building[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOBuilding}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (tenant.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{tenant[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOTenant}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (floor.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{floor[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOFloor}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (space.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{space[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOSpace}</Label>
                                            </Col> : ""
                                    }
                                </FormGroup>
                                <FormGroup row>
                                    {
                                        (problem.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{problem[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOProblem}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (equipment.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{equipment[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{WOEquipment}</Label>
                                            </Col> : ""
                                    }
        
                                </FormGroup>
                                {WOCustomFields}
                                <FormGroup row>
                                    {
                                        (description.length > 0) ?
                                            <Col sm={{ size: 8 }}>
                                                <Label className='workorderheaderlbl'>{description[0].fieldLabel}</Label><br />
                                                { WODescription !== "" ?
                                                    <pre className="workorderlbl" style={{wordWrap: "break-word", "line-height":"15px"}}>{WODescription}</pre> :
                                                    <Label className="workorderlbl-noentry">No Description</Label>
                                                }
                                            </Col> : ""
                                    }
                                </FormGroup>
                                </div>
                                <FormGroup row>
                                    {
                                        <Col sm={{ size: 8 }}>
                                            <Label className="workorderlbl" style={{'margin-bottom':'10px'}}>Supporting Document(s)</Label><br/>
                                            <Table responsive className="attachmentTable" style={{width:"90%"}}>
                                                <tbody>
                                                    <tr><th>ATTACHMENTS</th></tr>
                                                        {WOAttachements}  
                                                </tbody>
                                            </Table>
                                        </Col> 
                                    }
                                </FormGroup>
                                <hr style={{'margin-bottom':'0px','background-color':'black'}} />
                                <FormGroup row>
                                    <Col sm={{ size: 12 }}>
                                        <div style={{ backgroundColor: '#EEEEEE', 'width': '102.5%' }}>
                                            <FormGroup row>
                                                <Col sm={{ size: 12 }}>
                                                    <Label style={{ "padding-left": "37px", "padding-top": "24px" }} className='workordersubheaderlbl'>{label['WorkOrderDetails.WorkSummary.Text'] !== undefined ? label['WorkOrderDetails.WorkSummary.Text'] : "WORK SUMMARY"}</Label>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col sm={{ size: 12 }}>
                                                    <div style={{ "background-color": "white", "width": "98%", "height": "96%", "margin-left": "24px" }}>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Comments.Text'] !== undefined ? label['WorkOrderDetails.Comments.Text'] : "Comments"}</Label> &ensp;
                                                                <Button className="workorderbtn-black" style={{ "float": "right", "margin-top": "18px" }} onClick={() => { this.toggleComments() }} >ADD COMMENT </Button>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10}}>
                                                                <div style={{ 'display': this.state.commentModal, "margin-left": "15px", "margin-bottom": "12px", "position":"relative" }}>
                                                                    <FormGroup row style={this.state.isCommentEmpty ? {"margin-bottom": "0px"} : {}}>   
                                                                        <Col sm={{ size: 11}}>
                                                                            <textarea className={this.state.isCommentEmpty ? "errorhighlight custom_input default-input" : "custom_input default-input"} ref='WorkOrder_Comments' rows="4"   maxLength="1000" />
                                                                            <span hidden={!this.state.isCommentEmpty} style={{"position":"absolute","top":"50%"}}><Icon name='exclamation triangle' style={ErrorSign} /></span>                 
                                                                        </Col>
                                                                    </FormGroup>
                                                                    <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                                        <Col sm={{size:10}}>
                                                                            <div hidden={!this.state.isCommentEmpty}><Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></div>
                                                                            <Button className="btn-gray btn-md ChangeLimits_Cancelbtn" onClick={() => { this.toggleComments() }} >Cancel </Button>
                                                                            <Button className="btn-success btn-md ChangeLimits_Applybtn" onClick={() => { this.SaveComments() }} >Save </Button>
                                                                            <p style={{"display":"inline"}}><input type="checkbox" style={{ 'vertical-align': 'middle', 'cursor': 'pointer' }} id="chk_comment_notify" disabled={!HasMailSetting || !HasEmailAddress} defaultChecked={false} ref="ref_Comment_Notify" /> Notify Creator</p>  
                                                                        </Col>
                                                                    </FormGroup>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col sm={{ size: 10 }}>
                                                                <div className="table_container" style={{ "margin-left": "16px" }}>
                                                                    <Table striped responsive className="Custom_table fixed_layout"> 
                                                                        <tbody className="cell_container workordertbl-border OnPremisetbody">
                                                                            <tr>
                                                                                {/* <th onClick={this.onCommentSort('comments')}>{label['WorkOrders.Comments.Text'] !== undefined ? label['WorkOrders.Comments.Text'] : "COMMENTS"}&nbsp;&nbsp;<span style={{color:'white'}} className={(this.state.sort.direction[0].name == "comments")? (this.state.sort.direction[0].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="40%" onClick={this.onCommentSort('comments')}>{label['WorkOrders.Comments.Text'] !== undefined ? label['WorkOrders.Comments.Text'] : "COMMENTS"}
                                                                                    <span className={(this.state.sort.direction[0].name == "comments")? 
                                                                                    (this.state.sort.direction[0].onclick)?
                                                                                    (this.state.sort.direction[0].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[0].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onCommentSort('createdByUserName')}>{label['WorkOrders.CreatedBy.Text'] !== undefined ? label['WorkOrders.CreatedBy.Text'] : "CREATED BY"}&nbsp;&nbsp;<span className={(this.state.sort.direction[1].name == "createdByUserName")? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onCommentSort('createdByUserName')}>{label['WorkOrders.CreatedBy.Text'] !== undefined ? label['WorkOrders.CreatedBy.Text'] : "CREATED BY"}
                                                                                    <span className={(this.state.sort.direction[1].name == "createdByUserName")? 
                                                                                    (this.state.sort.direction[1].onclick)?
                                                                                    (this.state.sort.direction[1].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[1].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onCommentSort('createdOn')}>{label['WorkOrders.CreatedDate.Text'] !== undefined ? label['WorkOrders.CreatedDate.Text'] : "CREATED DATE"}&nbsp;&nbsp;<span className={(this.state.sort.direction[2].name == "createdOn")? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onCommentSort('createdOn')}>{label['WorkOrders.CreatedDate.Text'] !== undefined ? label['WorkOrders.CreatedDate.Text'] : "CREATED DATE"}
                                                                                    <span className={(this.state.sort.direction[2].name == "createdOn")? 
                                                                                    (this.state.sort.direction[2].onclick)?
                                                                                    (this.state.sort.direction[2].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[2].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                <th width="10%"></th>
                                                                            </tr>
                                                                            {WOComments}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrders.ViewDetails.Parts.Text'] !== undefined ? label['WorkOrders.ViewDetails.Parts.Text'] : "Parts"}</Label> &ensp;
                                                                <Button className="workorderbtn-black" style={{ "float": "right", "margin-top": "18px" }} onClick={() => { this.toggle() }} >ADD PART </Button>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col sm={{ size: 10 }}>
                                                                <div className="table_container" style={{ "margin-left": "16px" }}>
                                                                    <Table striped responsive className="Custom_table" style={{'table-layout':'fixed'}}>
                                                                        <tbody className="cell_container workordertbl-border OnPremisetbody">
                                                                            <tr>
                                                                                {/* <th onClick={this.onPartsSort('partName')}>{label['WorkOrders.PartsName.Text'] !== undefined ? label['WorkOrders.PartsName.Text'] : "NAME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[3].name == "partName")? (this.state.sort.direction[3].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onPartsSort('partName')}>{label['WorkOrders.PartsName.Text'] !== undefined ? label['WorkOrders.PartsName.Text'] : "NAME"}
                                                                                    <span className={(this.state.sort.direction[3].name == "partName")? 
                                                                                    (this.state.sort.direction[3].onclick)?
                                                                                    (this.state.sort.direction[3].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[3].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onPartsSort('partNumber')}>{label['WorkOrders.PartNumber.Text'] !== undefined ? label['WorkOrders.PartNumber.Text'] : "PART #"}&nbsp;&nbsp;<span className={(this.state.sort.direction[4].name == "partNumber")? (this.state.sort.direction[4].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="40%" onClick={this.onPartsSort('partNumber')}>{label['WorkOrders.PartNumber.Text'] !== undefined ? label['WorkOrders.PartNumber.Text'] : "PART #"}
                                                                                    <span className={(this.state.sort.direction[4].name == "partNumber")? 
                                                                                    (this.state.sort.direction[4].onclick)?
                                                                                    (this.state.sort.direction[4].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[4].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onPartsSort('quantity')}>{label['WorkOrders.PartQuantity.Text'] !== undefined ? label['WorkOrders.PartQuantity.Text'] : "QUANTITY"}&nbsp;&nbsp;<span className={(this.state.sort.direction[5].name == "quantity")? (this.state.sort.direction[5].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onPartsSort('quantity')}>{label['WorkOrders.PartQuantity.Text'] !== undefined ? label['WorkOrders.PartQuantity.Text'] : "QUANTITY"}
                                                                                    <span className={(this.state.sort.direction[5].name == "quantity")? 
                                                                                    (this.state.sort.direction[5].onclick)?
                                                                                    (this.state.sort.direction[5].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[5].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                <th width="10%"></th>
                                                                            </tr>
                                                                            {Parts}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Labor.text'] !== undefined ? label['WorkOrderDetails.Labor.text'] : "Labor"}</Label> &ensp;
                                                                <Button className="workorderbtn-black" style={{ "float": "right", "margin-top": "18px" }} onClick={() => { this.Labortoggle() }} >ADD LABOR </Button>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col sm={{ size: 10 }}>
                                                                <div className="table_container" style={{ "margin-left": "16px" }}>
                                                                    <Table striped responsive className="Custom_table" style={{'table-layout':'fixed'}}>
                                                                            <tbody className="cell_container workordertbl-border OnPremisetbody">
                                                                            <tr>
                                                                                {/* <th onClick={this.onLaborSort('userName')}>{label['WorkOrders.LaborName.Text'] !== undefined ? label['WorkOrders.LaborName.Text'] : "NAME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[6].name == "userName")? (this.state.sort.direction[6].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('userName')}>{label['WorkOrders.LaborName.Text'] !== undefined ? label['WorkOrders.LaborName.Text'] : "NAME"}
                                                                                    <span className={(this.state.sort.direction[6].name == "userName")? 
                                                                                    (this.state.sort.direction[6].onclick)?
                                                                                    (this.state.sort.direction[6].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[6].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('dateOfService')}>{label['WorkOrders.LaborDateofService.Text'] !== undefined ? label['WorkOrders.LaborDateofService.Text'] : "DATE OF SERVICE"}&nbsp;&nbsp;<span className={(this.state.sort.direction[7].name == "dateOfService")? (this.state.sort.direction[7].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('dateOfService')}>{label['WorkOrders.LaborDateofService.Text'] !== undefined ? label['WorkOrders.LaborDateofService.Text'] : "DATE OF SERVICE"}
                                                                                    <span className={(this.state.sort.direction[7].name == "dateOfService")? 
                                                                                    (this.state.sort.direction[7].onclick)?
                                                                                    (this.state.sort.direction[7].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[7].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('regularHour')}>{label['WorkOrders.LaborRegularHours.Text'] !== undefined ? label['WorkOrders.LaborRegularHours.Text'] : "REGULAR HOURS"}&nbsp;&nbsp;<span className={(this.state.sort.direction[8].name == "regularHour")? (this.state.sort.direction[8].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('regularHour')}>{label['WorkOrders.LaborRegularHours.Text'] !== undefined ? label['WorkOrders.LaborRegularHours.Text'] : "REGULAR HOURS"}
                                                                                    <span className={(this.state.sort.direction[8].name == "regularHour")? 
                                                                                    (this.state.sort.direction[8].onclick)?
                                                                                    (this.state.sort.direction[8].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[8].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('timeDuration')}>{label['WorkOrders.LaborOvertime.Text'] !== undefined ? label['WorkOrders.LaborOvertime.Text'] : "OVERTIME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[9].name == "timeDuration")? (this.state.sort.direction[9].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('timeDuration')}>{label['WorkOrders.LaborOvertime.Text'] !== undefined ? label['WorkOrders.LaborOvertime.Text'] : "OVERTIME"}
                                                                                    <span className={(this.state.sort.direction[9].name == "timeDuration")? 
                                                                                    (this.state.sort.direction[9].onclick)?
                                                                                    (this.state.sort.direction[9].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[9].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                <th width="10%"></th>
                                                                            </tr>
                                                                            {Labors}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                    </div>
                                                    <br/>
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </Col>
                                </FormGroup>
                                <div id="PrintWOSummary" style={{"display":"none"}}>
                                    {PrintWOSummary}
                                </div>
                            </Form>
                            <Modal isOpen={this.state.modal} toggle={this.toggle} contentClassName="resetContainer" >
                                <AddPartsForm ParentToChildData={[WODetails.workOrderID, this.state.isEdit, EditPartsDetails]} />
                            </Modal>
                            <Modal isOpen={this.state.labormodal} Labortoggle={this.Labortoggle} contentClassName="resetContainer" >
                                <AddLaborForm ParentToChildData={[WODetails.workOrderID, this.state.isLaborEdit, EditLaborDetails]} />
                            </Modal>
                            <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={"ModalContainer short_modal"} >
                                <DeleteConfirmation parentToChildData={["Delete Work Order", "You are about to delete a work order from the system. Do you want to continue?", "Close Window", "Delete Work Order"]} Delete={this.Delete} />
                            </Modal>
                            <div><img id="test_trane_logo" src={TraneLogo} style={{"display":"none"}}/></div>
                        </div>
                }
            </div>
        );
    }
};
const mapStateToProps = state => {
    return {
        getDetails: state.WorkorderRootReducer,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getCustomFields: state.WorkorderRootReducer.WorkOrderCustomFields,
        UserCanEdit: state.authService.HasWorkOrderAccess,
        getMailSetting: state.WorkorderRootReducer.MailSetting,
        getTechnicianDetails: state.WorkorderRootReducer.TechnicianDetails
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetWorkorderDetails: (WorkOrderID) => dispatch(GetWorkorderDetails(WorkOrderID)),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
        DeleteWorkorderParts: (data) => dispatch(DeleteWorkorderParts(data)),
        DeleteWorkOrder: (WorkOrderID, equipmentID) => dispatch(DeleteWorkOrder(WorkOrderID,equipmentID)),
        SaveComments: (data) => dispatch(SaveComments(data)),
        UpdateComments: (data) => dispatch(UpdateComments(data)),
        DeleteComments: (data) => dispatch(DeleteComments(data)),
        DeleteLaborDetails: (data) => dispatch(DeleteLaborDetails(data)),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        GetWorkorderTechnicianByID: (id) => dispatch(GetWorkorderTechnicianByID(id)),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        UpdateWorkOrder: (data, id) => dispatch(UpdateWorkOrder(data, id)),
        DownloadAttachment: (data) => dispatch(DownloadAttachment(data)),
        GetCustomFields: () => dispatch(GetCustomFields())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderDetails);